export const xor = (a: boolean, b: boolean): boolean => (a ? !b : b)
